import { fromJSON as dropdownFromJSON } from "common/components/Dropdown/Dropdown";
import { getPrettyName } from "common/helpers/Pretty";
import { Nullable } from "common/types";
import { List, Record } from "immutable";

export const patternTestDataFromJSON = (json: Partial<IPatternTestDataData>): PatternTestDataRecord => {
  const recordData: IPatternTestDataRecord = { ...(json as any) };

  return new PatternTestDataRecord(recordData);
};

export type TestDataDocType = "estimate" | "contract";

export const testDataDocTypes = List<TestDataDocType>(["estimate", "contract"]);

export const testDataDocTypesDropdown = testDataDocTypes.map((docType) =>
  dropdownFromJSON({
    id: docType,
    name: getPrettyName(docType),
  }),
);

export interface IPatternTestDataData {
  job_id: Nullable<number>;
  estimate_id: Nullable<number>;
  doc_type: TestDataDocType;
  locals: any;
}

export interface IPatternTestDataRecord {
  job_id: Nullable<number>;
  estimate_id: Nullable<number>;
  doc_type: TestDataDocType;
  locals: any;
}

export const defaultPatternTestDataProps: IPatternTestDataRecord = {
  job_id: null,
  estimate_id: null,
  doc_type: "estimate",
  locals: null,
};

export class PatternTestDataRecord extends Record(defaultPatternTestDataProps) implements IPatternTestDataRecord {}
